import { Capacitor } from "@capacitor/core";

const APP_HOST = "app.qkiere.com";

export function initDeepLinks() {
  if (!Capacitor.isNativePlatform()) return;
  import("@capacitor/app")
    .then(({ App }) => App.addListener("appUrlOpen", ({ url }) => {
      try {
        const link = new URL(url);
        if (link.hostname !== APP_HOST) return;
        window.location.replace(`${link.pathname}${link.search}`);
      } catch {}
    }))
    .catch(() => {});
}
